import { render, staticRenderFns } from "./consumableDetail.vue?vue&type=template&id=3b840367&"
import script from "./consumableDetail.vue?vue&type=script&lang=js&"
export * from "./consumableDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports